import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Por favor ingresa tu correo y contraseña");
      return;
    }

    if (email !== "admin@valuauto.com" || password !== "valuauto2026") {
      toast.error("Correo o contraseña incorrectos");
      return;
    }

    setLoading(true);
    // Simular un request de login
    setTimeout(() => {
      setLoading(false);
      localStorage.setItem("isAuthenticated", "true");
      navigate("/");
    }, 800);
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-background font-sans">
      {/* Left side - Branding */}
      <div className="w-full md:w-1/2 bg-[#121212] flex flex-col justify-center p-8 lg:p-24 relative overflow-hidden">
        {/* Subtle Watermark Icon */}
        <div className="absolute right-[-15%] bottom-[-15%] opacity-[0.07] pointer-events-none">
          <img src={`${process.env.PUBLIC_URL}/Iso_Valuauto_negro.png`} alt="Valuauto ISO" className="w-[400px] md:w-[600px] object-contain invert" />
        </div>

        <div className="relative z-10 w-full max-w-md mx-auto md:mx-0">
          <div className="absolute top-[-150px] md:top-[-200px] left-0">
            <img src={`${process.env.PUBLIC_URL}/logo-valuauto-blanco.svg`} alt="Valuauto" className="h-12 md:h-14 opacity-100" />
          </div>

          <h1 className="text-white text-4xl md:text-5xl font-bold mb-2 tracking-tight">
            Valuación precisa
          </h1>
          <h1 className="text-[#1c7b8c] text-4xl md:text-5xl font-bold mb-6 tracking-tight">
            en tiempo real.
          </h1>
          <p className="text-gray-400 text-sm md:text-base leading-relaxed mb-10 max-w-sm">
            Precios, tendencias y análisis del mercado —
            gestionados desde un panel simple,
            profesional y accesible desde cualquier
            dispositivo.
          </p>

          <div className="flex gap-4">
            <div className="border border-white/10 rounded-lg p-3 w-28">
              <div className="text-white font-bold text-lg">100%</div>
              <div className="text-gray-500 text-[10px] tracking-widest mt-1">MERCADO</div>
            </div>
            <div className="border border-white/10 rounded-lg p-3 w-28">
              <div className="text-white font-bold text-lg">24/7</div>
              <div className="text-gray-500 text-[10px] tracking-widest mt-1">ACTUALIZADO</div>
            </div>
            <div className="border border-white/10 rounded-lg p-3 w-28">
              <div className="text-white font-bold text-lg">DATOS</div>
              <div className="text-gray-500 text-[10px] tracking-widest mt-1">PRECISOS</div>
            </div>
          </div>

          <div className="absolute bottom-[-150px] md:bottom-[-200px] left-0 text-[#555] text-[10px] tracking-widest">
            VALUAUTO · ECOSISTEMA <span className="font-bold">AUTOHUB</span>
          </div>
        </div>
      </div>

      {/* Right side - Login Form */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-8 lg:p-24 bg-white">
        <div className="w-full max-w-sm animate-fade-in">

          <div className="text-center md:text-left mb-10">
            <img
              src={`${process.env.PUBLIC_URL}/logo-valuauto-blanco.svg`}
              alt="Valuauto Logo"
              className="h-14 md:h-16 mb-12 invert"
            />
            <h2 className="text-2xl font-bold text-slate-900 mb-2">Ingresar al sistema</h2>
            <p className="text-slate-500 text-sm">
              Ingresá tus credenciales para acceder al panel de gestión.
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div className="space-y-5">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-[10px] font-bold text-gray-500 tracking-widest uppercase">Usuario</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="Nombre de usuario"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full h-11 transition-all focus:ring-1 focus:ring-[#1c7b8c] focus:border-[#1c7b8c] rounded-md"
                  required
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password" className="text-[10px] font-bold text-gray-500 tracking-widest uppercase">Contraseña</Label>
                <Input
                  id="password"
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full h-11 transition-all focus:ring-1 focus:ring-[#1c7b8c] focus:border-[#1c7b8c] rounded-md"
                  required
                />
              </div>
            </div>

            <Button type="submit" className="w-full h-12 text-base font-medium transition-all bg-[#1c7b8c] hover:bg-[#165e6b] text-white rounded-md mt-4" disabled={loading}>
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Ingresando...
                </>
              ) : (
                "Ingresar"
              )}
            </Button>
          </form>

          <div className="mt-16 text-center">
            <p className="text-[10px] text-gray-400 font-medium tracking-[0.2em] uppercase">Parte del ecosistema <span className="font-bold text-gray-600">AutoHub</span></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
